/**
 * Simple Product Accordion Controller
 * Ensures only one accordion is open at a time
 */

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Find product section and its accordions
    const productSection = document.querySelector('.product');
    if (!productSection) return;
    
    const accordions = productSection.querySelectorAll('accordion-tab.product__accordion');
    if (accordions.length <= 1) return; // No need for single accordion
    
    // Listen for clicks on the product section
    productSection.addEventListener('click', function(event) {
      // Only handle summary elements
      const summary = event.target.closest('summary');
      if (!summary) return;
      
      const clickedAccordion = summary.closest('accordion-tab.product__accordion');
      if (!clickedAccordion) return;
      
      const clickedDetails = clickedAccordion.querySelector('details');
      if (!clickedDetails) return;
      
      // Skip if the accordion is already open
      if (clickedDetails.open) return;
      
      // Close all other open accordions before this one opens
      // We don't stop the event - let the built-in handler open this one
      accordions.forEach(function(accordion) {
        if (accordion !== clickedAccordion) {
          const details = accordion.querySelector('details');
          if (details && details.open) {
            // Use built-in shrink method if available for smooth animation
            if (typeof accordion.shrink === 'function') {
              accordion.shrink();
            } else {
              details.open = false;
            }
          }
        }
      });
    }, true); // Use capture phase to handle before the accordion's own handler
    
    console.log('Simple product accordion controller initialized');
  });
})();
